import { connect } from 'react-redux';

import { StoreState } from '../../../reducers';
import SharedDocuments from '../../../components/Share/SharedDocuments';

const mapStateToProps = (state: StoreState) => {
	const { sharePanel: { selectedResources } } = state;

	return { selectedResources };
};

export default connect(mapStateToProps)(SharedDocuments);


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/Share/SharedDocuments/index.tsx